<template>
    <div class="bg-neutral-white">
      <CCol sm="12" xs="6" class="text-right">
        <h5 class="custom-18px poppin-font mt-0 text-center" style="padding-top: 40px;">
          <img style="max-width: 40px; float: left; margin-right: 10px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
            <span style="margin-top:20px">About Us</span>
        </h5>
      </CCol>
      <div style="clear:both"></div>
      
      <CCol sm="12">
        <div class="m-0 justify-content-center align-items-center">
          <div class="m-1">
            <label class="custom-font-setting mt-3" style="font-size: 20px; font-weight: 600px;">About Us</label> 

            <CRow class="m-1">
              <div class="card-grey-50px">
                <label class="custom-12px custom-font-setting" style="top: 7px; left: 13px; position: absolute;">v1.1.0</label>
              </div>
              <label class="custom-14px ml-2" style="top: 15px; position: relative;"> Published on </label>
              <label class="custom-font-setting ml-2" style="position: relative; top: 13px;"> February, 2023 </label>
            </CRow> 
            <br />

            <div class="border-white-50px" style="width: 50%;">
              <img style="max-width: 25px;" src="../assets/img/download.png"  />
              <label class="custom-font-setting ml-2" style="margin-top: 10px;"> Download as PDF </label>
            </div>
            <br />

            <p class="custom-font-setting ml-2">
              Protecting your privacy is a top priority at our parcel delivery app. We understand that you entrust us with your personal information, and we take that responsibility seriously.
            </p>
            <p class="custom-font-setting ml-2">
              When you use our app, we collect and use information only as necessary to provide our services and improve your experience. This includes information such as your name, address, and delivery details. We also use cookies and similar technologies to personalize your experience and track usage data.
            </p>
            <p class="custom-font-setting ml-2">
              We do not sell your information to third parties, and we only share it with our trusted partners and service providers when necessary to provide our services. We take reasonable steps to protect your information from unauthorized access, disclosure, or misuse.
            </p>
            <p class="custom-font-setting ml-2">
              If you have any questions or concerns about our privacy practices, please don't hesitate to contact us. Your trust and satisfaction are important to us, and we will do everything we can to protect your privacy and ensure your peace of mind.
            </p>

            
            <br /><br />
          </div>
          
          <br /><br /><br /><br /><br /><br /> <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
          
          
          <br /><br />
        </div>
      
             
      
      
      
      </CCol>
    </div>
  </template>
  
  
  <script>
  import MainlayoutBottom from "../containers/TheBottomCustom.vue";
  import {
      Hooper,
      Slide,
      Navigation as HooperNavigation,
      Pagination as HooperPagination,
  } from "hooper";
  
  import "hooper/dist/hooper.css";
  export default ({
      components: {
          Hooper,
          Slide,
          HooperNavigation,
          HooperPagination,
          MainlayoutBottom,
      },
      data() {
          return {
              isLanguagePopupVisible: false,
              code: ["", "", "", ""],
              hooperSettings1: {
                  hideArrows: true,
              },
              successPopup: false,
  
          }
  
      },
      methods: {
          GoToPrevious() {
              this.$router.go(-1);
          },
  
        //   GoToLogin() {
        //       // Close the popup and backdrop
        //       this.$router.push("/RegisterHomepage");
        //   },
  
        //   GoToChangePassword() {
        //       // Close the popup and backdrop
        //       this.$router.push("/ChangePassword");
        //   },
        //   submitVerification() {
        //       const verificationCode = this.code.join(""); // Concatenate the digits
        //       console.log("Verification Code:", verificationCode);
  
        //       this.popupSuccess = true;
  
        //       // Add your logic to handle the verification code
        //   },
  
        GoToWhatsapp() {
          this.$router.push("/EditProfile");
        },

        connectSuccess() {
          this.successPopup = true;
        },

        closePopup() {
          this.$router.push("/EditSocmed");
        }
  
      }
  })
  </script>
  
  <style scoped>
  body {
      top: 0 !important;
      font-family: 'Poppins', sans-serif;
  }

  .switch {
  position: relative;
  display: inline-grid;
  width: 50px;
  height: 25px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #DDE0EE;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 2px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #323C66;
}



input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
  </style>